import { SharedModel } from '../sharedmodel';
import { A365Named } from '../base/a365Named';
import { IMDEntity } from './interface';

export type IExecuteChangeActionType = 'CREATE' | 'ALTER';

export abstract class DatabaseEntity extends A365Named implements SharedModel.ITreeLike {
    public parentInfo: SharedModel.IParentInfo; // parentName is case insensitive as the database name is case insensitive
    public name: string;
    public description?: string;
    public rawContentInJson?: string; // used in generating payload when calling executeChange
    public alterAction?: IExecuteChangeActionType | undefined; // used in generating payload when calling executeChange
    public mDEntity?: IMDEntity; // the value is returned from backend, for a new entity, the value would be undefined
    public originInstanceId?: string; // This value needs to be persisted and used in the update flow

    constructor(name: string, description: string, parentInfo: SharedModel.IParentInfo) {
        super(name, description);
        this.parentInfo = parentInfo;
    }

    get realName(): string {
        return this.name;
    }
}
